module.exports = __webpack_public_path__ + "static/media/iconFriends.6bdb34eb.svg";